import React, { useState } from 'react'
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import { useTheme } from '../../../components/hooks/useTheme';

const Security = () => {
    const { themeStyles } = useTheme();
    const [isSecurity, setIsSecurity] = useState<boolean>(false);

    return (
        <div>
            <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                onClick={() => setIsSecurity(!isSecurity)}
            >
                {isSecurity ? (
                    <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                ) : (
                    <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                )}{" "}
                <div className="w-full flex flex-row justify-between items-center">
                    <div style={{ color: themeStyles.topBar.textColor }}>Security</div>
                </div>
            </h5>
            <hr />

            {isSecurity &&
                <div>
                    <div style={{ color: themeStyles.topBar.textColor }}>Security</div>
                </div>
            }
        </div>
    )
}

export default Security